// extracted by mini-css-extract-plugin
export default {"cart_bonuses":"cart_bonuses_cart_bonuses__dwJFA","cart_bonuses__text":"cart_bonuses_cart_bonuses__text__LNOBj","cart_bonuses__badge":"cart_bonuses_cart_bonuses__badge__VI3xj"};